import React, {Component}  from "react";
import PropTypes from 'prop-types';
import {withRouter, Link} from 'react-router-dom';

import CourseStatistic from './CourseStatistic';
import OverviewStudents from './OverviewStudents';
import ResponsesModal from './ResponsesModal';

class DashboardAdmin extends Component {
    constructor(props){
        super(props);

        this.state = {
            courseId: null
        }
    }

    //Renders
    renderContentDashboard = (adminInfo) => {
        let course = null;
            if(this.state.courseId) {
                course = this.props.courses.filter(c => c.id === this.state.courseId)[0];
            }
            return (
                <div className="nav-tabs-custom no-bg">
                    <ul className="nav nav-tabs bg-white">
                        <li className={!this.props.match.params.courseId ? 'active' : ''}>
                            <Link
                                to="/dashboard-admin"

                            >
                                Overview
                                <span>
                                General
                            </span>
                            </Link>
                        </li>
                        {this.props.profile.role === 'admin' ?
                            this.props.courses ?
                            this.renderNavList(this.props.courses)
                            : null
                            : this.renderInstructorNavList(this.props.allCourseUsers)
                        }
                    </ul>
                    <div className="tab-content no-bg">
                        
                            {
                                adminInfo.adminEvents && !this.props.match.params.courseId && 
                                <OverviewStudents
                                    adminEvents={adminInfo.adminEvents}
                                    events={this.props.events}
                                    studentCount={this.props.studentCount}
                                    studentOnlineCount={this.props.studentOnlineCount}
                                    courses={this.props.courses}
                                    user={this.props.user}
                                    createEvent={(event) => this.props.createEvent(event, this.props.user.userId)}/>
                            }
                               

                            {this.props.match.params.courseId &&
                                <CourseStatistic
                                    course={course}
                                    buildChart={this.props.buildChart}
                                    user={this.props.user}
                                    chart={this.props.chart}
                                    chartX={this.props.chartX}
                                    chartError={this.props.chartError}
                                    chartType={this.props.chartType}
                                    chartLoading={this.props.chartLoading}
                                    courseId={this.props.match.params.courseId}
                                    usersStatus={adminInfo.usersStatus || {}}
                                    users={[]} />
                            }

                     



                    </div>
                </div>
            )
        }



    renderInstructorNavList = (cu) => {
        return cu.map((c, i) => {
            return (
                <li
                    key={i}
                    className={this.props.match.params.courseId === c.Course.id ? 'active' : ''}
                >
                    <Link
                        to={`/dashboard-admin/${c.Course.id}`}

                    >
                        {c.Course.name}

                        <span> Subheading</span>
                    </Link>
                </li>
            );
        })
    }

    renderNavList = (navbarMenu) => (
        navbarMenu.map((item,index) => {

                return (
                    <li
                        key={index}
                        className={this.props.match.params.courseId === item.id ? 'active' : ''}
                    >
                        <Link
                            to={`/dashboard-admin/${item.id}`}

                        >
                            {item.name}

                            <span> Subheading</span>
                        </Link>
                    </li>
                );

        })
    );

    renderNavListDropdown = (childlist) => (
        childlist.map((item, index) => (
            <li
                role={item.role}
                key={index}
            >
                <a
                    role={item.roleLink}
                    tabIndex="-1"
                    href={item.link}
                >
                    {item.title}
                </a>
            </li>
        ))
    );

    //Lifecycle
    componentDidMount() {
        this.props.onLoadInfo();
        this.props.getCourseUsers(this.props.user.user.Profile.id, this.props.user.id);
        this.props.onLoadCourses(this.props.user.userId, this.props.user.id);
        this.props.getEvents(this.props.user.userId, this.props.user.id);
        this.props.hideLoader();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId && this.props.match.params.courseId){
            this.props.getCourseUsersByCourseId(this.props.match.params.courseId, this.props.user.id);
        }
    }

    render() {
        const {adminInfo} = this.props;

        return (
            <div
                className="content-wrapper"
                id="content-container"
            >
                <div className="bg-light lter b-b wrapper-md">
                    <div className="row">
                        <div className="col-sm12 col-xs-12">
                            <h1 className="m-n font-thin h3 text-black">
                                The Dashboard
                            </h1>
                            <small className="text-muted">
                                Everything Starts Here
                            </small>
                        </div>
                    </div>
                </div>
                <section className="content no-padding">
                    {
                        adminInfo &&
                        this.renderContentDashboard(adminInfo)
                    }
                </section>
                {
                    adminInfo.usersResponses &&
                    <ResponsesModal usersResponses={adminInfo.usersResponses} courses={this.props.courses} />
                }


            </div>
        );
    }

}

DashboardAdmin.propTypes = {
    onLoadInfo: PropTypes.func.isRequired,
    adminInfo: PropTypes.shape({
        adminEvents: PropTypes.object,
        usersStatus: PropTypes.object,
        usersOnline: PropTypes.object,
        usersResponses: PropTypes.array,
        navbarMenu: PropTypes.array
    })
};

export default withRouter(DashboardAdmin);


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardAdmin/DashboardAdmin.js